import { render, staticRenderFns } from "./PainelChamadosSecli.vue?vue&type=template&id=02ec1663"
import script from "./PainelChamadosSecli.vue?vue&type=script&lang=js"
export * from "./PainelChamadosSecli.vue?vue&type=script&lang=js"
import style0 from "./PainelChamadosSecli.vue?vue&type=style&index=0&id=02ec1663&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports